module.exports = __webpack_public_path__ + "static/media/african-lion-2888519_640-min.5e9c2a4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/african-lion-2888519_640-min.jpg
// module id = 132
// module chunks = 0